module.exports = __webpack_public_path__ + "static/media/fullTicketWhite.97eaeb8d.png";